module.exports = __webpack_public_path__ + "static/img/UBC老师_Cathy.2bf961e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC老师_Cathy.png
// module id = 7DfS
// module chunks = 0